import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Split content layout: heading on the left (5 cols), paragraphs + inline link on the right (7 cols).
 * Matches reference "How we align" / "Considerations for this sector" style
 * when the right column has paragraphs (not list items).
 */
export default function SplitContent({ section }) {
  const { eyebrow, heading, paragraphs = [], links = [], theme = "white" } = section;
  const bgClass = theme === "navy" ? "bg-mist-navy text-white" : theme === "off" ? "bg-mist-off" : "bg-white";
  const headingColor = theme === "navy" ? "text-white" : "text-mist-navy";
  const paraColor = theme === "navy" ? "text-white/80" : "text-mist-ink/80";
  const linkColor = theme === "navy" ? "text-mist-gold hover:text-white" : "text-mist-navy hover:text-mist-gold";

  return (
    <section className={`${bgClass} py-24 lg:py-32`}>
      <div className="container-mist grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="max-w-2xl text-left">
            {heading && (
              <h2
                className={`font-display text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] tracking-tight ${headingColor}`}
              >
                {heading}
              </h2>
            )}
            {(eyebrow || heading) && <div className="mt-4 gold-divider" />}
          </div>
        </div>
        <div className={`lg:col-span-7 text-[15px] leading-relaxed space-y-5 ${paraColor}`}>
          {paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
          {links.map((l, i) => (
            <Link
              key={i}
              to={l.href}
              data-testid={l.testid || `split-link-${i}`}
              className={`inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] transition link-underline ${linkColor}`}
            >
              {l.label}
              <ArrowRight className="h-3.5 w-3.5" aria-hidden />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
